
export default function FieldGroup({ children, className }) {
    return <div className={`Field-group ${className ? className : ""}`}>{children}</div>;
}
